import { Component, ViewEncapsulation, Input, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor, NgTemplateOutlet, NgSwitch, NgSwitchCase, NgSwitchDefault, AsyncPipe } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { ProductTranslationService, PRODUCT_NAMESPACE_RTPC_FIELD } from '../../../services/product-translation.service';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';
import { TextFieldDirective } from '../../../../shared/directives/input-textfield.directive';
import { InputNumberDirective } from '../../../../shared/directives/input-number.directive';

import { FieldObjectCst } from './utils/field/field-object';
import { LayoutProductCard } from './utils/product-card-layout-builder';
import { buildLayout } from './utils/product-layout-builder';
import { FieldValue, Field } from './utils/field/field';

@Component({
	selector: 'copo-product-card-content',
	templateUrl: './product-card-content.component.html',
	styleUrl: './product-card-content.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		NgFor,
		NgTemplateOutlet,
		TranslateModule,
		MatDividerModule,
		NgSwitch,
		NgSwitchCase,
		NgSwitchDefault,
		MatIconModule,

		MatInputModule,
		FormsModule,
		InputNumberDirective,
		ReactiveFormsModule,

		MatButtonModule,

		MatFormFieldModule,
		TextFieldDirective,

		MatAutocompleteModule,

		MatTooltipModule,

		MatOptionModule,
		AsyncPipe,
		NumberPipe,
	],
})

export class ProductCardContentComponent implements OnInit, OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() productFieldsObs!: Observable<FieldObjectCst>;
	layout?: LayoutProductCard;

	readonly NUMBER_CST = 'numberCst';
	readonly NUMBER_VAR = 'numberVar';
	readonly TEXT_CST = 'textCst';
	readonly TEXT_VAR = 'textVar';
	readonly TEXT_SELECTION = 'textSelection';
	readonly LIST_CST = 'listCst';
	readonly LIST_VAR = 'listVar';

	private sub!: Subscription;

	constructor(
		private readonly productTranslationService: ProductTranslationService
	) {}

	ngOnInit() {
		this.sub = this.productFieldsObs.subscribe(productFields => {
			this.layout = buildLayout(productFields);
		});
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}

	translate(value: string, index?: number) {
		const label = this.productTranslationService.translate(`${ PRODUCT_NAMESPACE_RTPC_FIELD }${ value }`);
		return index === undefined ? label : `${ label }\u00A0${ index + 1 }`;
	}

	findFieldByRadical(
		fields: Field<FieldValue>[],
		radical: string
	) {
		return fields.find(field => field.name.toLowerCase().includes(radical));
	}

	findFieldByForbiddenRadical(
		fields: Field<FieldValue>[],
		forbiddenRadical: string[]
	) {
		return fields.find(field => !forbiddenRadical.some(type => field.name.toLowerCase().includes(type)));
	}
}
